import { createContext, useContext } from "react";
import { useSelector } from "react-redux";

export const ClientConfigOverride = createContext<any>(null);

const useClientConfig = () => {
    const careersConfig = useSelector((state: any) => state.careers.cliendConfig);
    const override = useContext(ClientConfigOverride);
    const clientConfig = override ?? careersConfig;
    const isMicroSite = clientConfig?.data?.data?.clientSettings?.isMicroSite;
    const clientSiteSettings = clientConfig?.data?.data?.clientSettings?.clientSiteSettings;
    const clientMenuSettings = clientConfig?.data?.data?.clientSettings?.clientMenuSettings;
    const clientAssetsLink = clientConfig?.data?.data?.clientSettings?.assetsLink;
    return { clientConfig, clientSiteSettings, clientMenuSettings, clientAssetsLink, isMicroSite };
};

export default useClientConfig;